import { render, staticRenderFns } from "./custom-components.datatable.vue?vue&type=template&id=0089237b&scoped=true&"
import script from "./custom-components.datatable.vue?vue&type=script&lang=js&"
export * from "./custom-components.datatable.vue?vue&type=script&lang=js&"
import style0 from "./custom-components.datatable.vue?vue&type=style&index=0&id=0089237b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0089237b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
